/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReportTab200ResponseCustomer
 */
export interface GetReportTab200ResponseCustomer {
    /**
     * 
     * @type {string}
     * @memberof GetReportTab200ResponseCustomer
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof GetReportTab200ResponseCustomer
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof GetReportTab200ResponseCustomer
     */
    email?: string;
}

/**
 * Check if a given object implements the GetReportTab200ResponseCustomer interface.
 */
export function instanceOfGetReportTab200ResponseCustomer(value: object): value is GetReportTab200ResponseCustomer {
    return true;
}

export function GetReportTab200ResponseCustomerFromJSON(json: any): GetReportTab200ResponseCustomer {
    return GetReportTab200ResponseCustomerFromJSONTyped(json, false);
}

export function GetReportTab200ResponseCustomerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReportTab200ResponseCustomer {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function GetReportTab200ResponseCustomerToJSON(json: any): GetReportTab200ResponseCustomer {
    return GetReportTab200ResponseCustomerToJSONTyped(json, false);
}

export function GetReportTab200ResponseCustomerToJSONTyped(value?: GetReportTab200ResponseCustomer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'phoneNumber': value['phoneNumber'],
        'email': value['email'],
    };
}

